"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function convertCurrencyFormat(amount) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var maximumFractionDigits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var maximumFractionCheck = minimumFractionDigits > maximumFractionDigits ? minimumFractionDigits : maximumFractionDigits;
  return amount.toLocaleString('en', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionCheck
  });
}
var _default = exports.default = convertCurrencyFormat;